module.exports = __webpack_public_path__ + "static/media/back-arrow.8ab7f7b1.svg";